import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTechnician } from "../../redux/technician/technicianSlice";
import Logo from "../Logo";
import { useListTechniciansQuery } from "../../api/managementApi";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../consts/i18n";
import TextInput from "../inputs/TextInput";
import LanguageSwitcher from "../UI/LanguageSwitcher";

export const TechnicianNameOverlay = ({ projectId }) => {
  const dispatch = useDispatch();
  const selectedTechnician = useSelector((state) => state.technician);
  const [guestName, setGuestName] = useState("");

  const [technicianId, setTechnicianId] = useState("");

  const { t } = useTranslation(namespaces.viewer);

  const { data: technicians, isLoading } = useListTechniciansQuery({
    projectId,
  });

  function confirmTechnicianSelection() {
    var technician = technicians.find((t) => t.id === technicianId) || {
      name: guestName,
    };
    dispatch(setTechnician(technician));
  }

  return (
    <>
      {!selectedTechnician.name && (
        <section className="p-8 absolute z-40 flex flex-col justify-center items-center h-full w-full bg-black/70">
          <Logo fill="#FFF" />
          <h3 className="text-xxxl font-bold text-center whitespace-pre-wrap break-words text-white mt-[72px] text-[22px] mb-[32px]">
            {t("technicianNameOverlay.title")}
          </h3>
          <div className="max-w-[580px] flex flex-row flex-wrap gap-x-[18px] gap-y-[16px] justify-center">
            {!isLoading &&
              technicians.map((technician) => (
                <button
                  className={`rounded-full h-[45px] px-[25px] text-700 font-bold shadow-sm text-[14px] flex items-center hover:bg-primary hover:text-white justify-center disabled:opacity-50 ${technicianId === technician.id ? "bg-primary text-white" : "text-black bg-white"}`}
                  onClick={() => setTechnicianId(technician.id)}
                  key={technician.id}
                >
                  {technician.name}
                </button>
              ))}
          </div>
          {!isLoading && technicians.length === 0 && (
            <TextInput
              onChange={setGuestName}
              value={guestName}
              inputClassName={"font-bold text-center min-w-[280px]"}
              label={t("technicianNameOverlay.guestNameLabel")}
              labelClassName={"text-center text-white m-12 text-lg"}
            />
          )}
          <button
            className="mt-[100px] font-semibold mx-auto block rounded-lg min-w-[280px] h-[64px] px-4 py-4 bg-primary text-white disabled:cursor-not-allowed"
            disabled={technicianId === null}
            onClick={confirmTechnicianSelection}
          >
            {t("technicianNameOverlay.selectTechnician")}
          </button>
          <span className="text-xxxl font-bold text-center whitespace-pre-wrap break-words text-white mt-[105px] text-[22px] mb-[32px]">
            {t("technicianNameOverlay.usageGuide")}
          </span>
          <LanguageSwitcher />
        </section>
      )}
    </>
  );
};
